export default [
    {
        value: "paid",
        label: "Paid"
    },
    {
        value: "procured",
        label: "Procured"
    }
]